import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandStyles: {
    switch: 'padding: 0.125rem 0.25rem'
  }
} satisfies RecursivePartial<VfConfig['switch']>
